import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { CaretDown } from "components/icons/CaretDown";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useCrmTabs } from "hooks/useCrmTabs";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { Group } from "types/Models/group";
import { getCrmTabState } from "util/getCrmTabState";

type CrmMobilePageNavProps = {
  data: Group | null;
};

export const CrmMobilePageNav = ({ data }: CrmMobilePageNavProps) => {
  const crmTabs = useCrmTabs(data);
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const { link } = useConstructInternalLink();

  const pages = crmTabs.map((tab) => ({
    name: tab.name,
    ...getCrmTabState({ tab, url, pathname, link }),
  }));

  const selectedPage = pages.find((page) => page.isSelected);

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button size="small" block>
          <span className="t-flex t-w-full t-items-center t-justify-between t-gap-2">
            <span className="t-truncate t-capitalize">
              {selectedPage?.name ?? "Go to page"}
            </span>
            <CaretDown />
          </span>
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="start" className="t-max-h-80">
          {pages.map(({ name, to, isSelected }) => (
            <Dropdown.Item key={to} onSelect={() => history.push(to)}>
              <span
                className={classNames("t-capitalize", {
                  "t-font-medium t-text-text-100": isSelected,
                })}
              >
                {name}
              </span>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
